import { ReturnOrders } from '@/features/profile-page/ReturnOrders/ui/ReturnOrders'
import './ui/ReturnOrders.css'
export default ReturnOrders
